<!--
  @Description 模块菜单制单界面
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="card">
    <el-row>
      <el-col :span="24">
        <div class="buttonContainer">
          <!-- <el-button
            type="success"
            :disabled="!parentData.Authority.edit"
            size="small"
            icon="iconfont fjyk-save"
            @click="save"
            >保存</el-button
          >
          <el-button
            type="primary"
            :disabled="!parentData.Authority.edit"
            size="small"
            icon="iconfont fjyk-excel"
            @click="importExcel"
            >导入Excel</el-button
          >
          <el-button
            type="danger"
            :disabled="!parentData.Authority.edit"
            size="small"
            icon="el-icon-delete"
            @click="del"
            >删除</el-button
          >
          <el-button
            type="danger"
            size="small"
            icon="iconfont fjyk-back"
            @click="back"
            >返回</el-button
          > -->
          <div class="toolbar-dv">
            <toolBarBtn
              :parentData="this"
              :buttonVisible="buttonVisible"
              :moreButtonList="moreButtonList"
              ref="toolBarBtn"
            ></toolBarBtn>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="small"
    >
      <!-- 第一行 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="产品类型" prop="productionType">
            <el-select
              clearable
              v-model="form.productionType"
              :placeholder="placeholderConfig.select"
              :disabled="!Authority.edit || form.lockerID > 0 || dontEdit"
              @change="changeType"
            >
              <el-option
                v-for="i of ComBoxItems.productionType"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品版本" prop="productionVersion">
            <el-select
              clearable
              v-model="form.productionVersion"
              :placeholder="placeholderConfig.select"
              :disabled="!Authority.edit || form.lockerID > 0 || dontEdit"
            >
              <el-option
                v-for="i of ComBoxItems.productionVersion"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="memo">
            <el-input
              v-model="form.memo"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || form.lockerID > 0 || dontEdit"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-divider content-position="left">数据列表</el-divider> -->
    <YKDivider content-position="left">明细列表</YKDivider>
    <!-- 菜单权限明细table -->
    <vxe-grid
      ref="xTable"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight"
      :cell-class-name="cellClassName"
      resizable
      :edit-rules="validRules"
      show-overflow
      :data="form.detailList"
      highlight-hover-row
      highlight-current-row
      :mouse-config="{ area: true, extension: true }"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod,
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod,
      }"
      :menu-config="{
        body: { options: bodyMenus },
        visibleMethod: visibleMethod,
      }"
      :columns="tableColumns"
      @menu-click="contextMenuClickEvent"
      @cell-menu="cellContextMenuEvent"
      :toolbar-config="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
    >
    </vxe-grid>
    <!-- 角色选择框 -->
    <EmployeeSelect
      ref="EmployeeSelect"
      :isMultiple="false"
      @sureBackPerson="sureBackPerson"
    />
    <!-- 导入excel -->
    <ExcelImport ref="ExcelImport" @sureImportBack="sureImportBack" />
    <!-- 批量输入 -->
    <BatchInput ref="BatchInput" @sureHandler="sureBackBatch" />
  </div>
</template>

<script>
import ExcelImport from './import.vue'
export default {
  components: {
    ExcelImport
  },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            edit: false,
            see: false
          }
        }
      }
    },
    joinID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      id: 0,
      // 表单
      form: {
        productionType: '',
        productionVersion: '',
        memo: '',
        lockDate: '',
        locker: '',
        lockerID: 0,
        writeDate: '',
        writer: '',
        writerID: 0,
        detailList: []
      },
      // 校验规则
      rules: {
        productionType: [
          { required: true, message: '请输入产品类型', trigger: 'change' },
          {
            min: 0,
            max: 10,
            message: '产品类型长度应在 0 到 10 个字符',
            trigger: 'change'
          }
        ],
        productionVersion: [
          { required: true, message: '请输入产品版本', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '产品版本长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {
        productionType: [],
        productionVersion: []
      },
      // 校验
      validRules: {
        groupName: [
          { required: true, message: '请输入模块名', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '模块名长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        vuePath: [
          { required: true, message: '请输入页面名', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '页面名长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        frontEngineer: [
          {
            min: 0,
            max: 5,
            message: '前端研发长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        backEngineer: [
          {
            min: 0,
            max: 5,
            message: '后端研发长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        techTester: [
          {
            min: 0,
            max: 5,
            message: '技术测试长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        businessTester: [
          {
            min: 0,
            max: 5,
            message: '业务测试长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        dMemo: [
          {
            min: 0,
            max: 64,
            message: '说明长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      },
      // 动态列
      tableColumns: [],
      bodyMenus: [[
        {
          code: 'batchInput',
          name: '批量输入'
        },
        {
          code: 'pickMan',
          name: '选择人员'
        },
        {
          code: 'setNull',
          name: '设置为空'
        },
        {
          code: 'clear',
          name: '清空'
        },
      ]],
      errIndex: [],
      // tabel工具栏
      tableToolbar: {
        buttons: [
          {
            code: 'insertOne',
            name: '新增1行',
            disabled: true
          },
          {
            code: 'insertTen',
            name: '新增10行',
            disabled: true
          }
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      buttonVisible: {
        add: false,
        save: false,
        delete: false,
        update: false,
        refresh: false,
        search: false,
        sort: false,
        lock: false,
        unlock: false,
        more: false
      },
      moreButtonList: [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: true,
          event: 'save'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: true,
          event: 'delete'
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          disabled: true,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          disabled: true,
          event: 'unlock'
        },
        {
          name: '导入Excel',
          icon: 'iconfont fjyk-daoru-03-copy',
          disabled: true,
          event: 'importExcel'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: true,
          event: 'back'
        },
      ],
      ifAdd: false,
      // 是否绑定完成
      IfDataBindComplete: false,
      // 是否不能编辑
      dontEdit: true
    }
  },
  created() {
    this.InitColumn()
    this.InitSetting()
    this.BindComBox()
    this.id = this.joinID ? this.joinID : 0
    this.BindText()
  },
  mounted() {
  },
  methods: {
    // 获取权限
    InitRight() {
      this.dontEdit = Boolean(this.form.writerID && this.form.writerID !== this.$store.state.userInfo.userId)
      this.tableToolbar = {
        buttons: [
          {
            code: 'insertOne',
            name: '新增1行',
            disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          },
          {
            code: 'insertTen',
            name: '新增10行',
            disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          }
        ]
      }
      this.moreButtonList = [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          event: 'save'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: this.id === 0 || !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          event: 'delete'
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          disabled: !this.id || !this.Authority.edit || this.form.lockerID > 0,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          disabled: !this.id || !this.Authority.edit || this.form.lockerID <= 0,
          event: 'unlock'
        },
        {
          name: '导入Excel',
          icon: 'iconfont fjyk-daoru-03-copy',
          disabled: !this.Authority.edit || this.form.lockerID > 0 || this.dontEdit,
          event: 'importExcel'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          disabled: false,
          event: 'back'
        },
      ]
      this.InitColumn()
    },
    // 导入excel
    importExcel() {
      this.$refs.ExcelImport.isShow = true
    },
    // 返回excel
    sureImportBack(List) {
      if (List.length > 0) {
        for (let item of List) {
          this.$refs.xTable.insertAt(item)
        }
        this.IfExistModify = true
      }
    },
    // 批量输入返回
    sureBackBatch(str) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = str
            }
          }
        }
      })
    },
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 新增
    async add() {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      form.detailList = insertRecords
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.post('/Common/BMenuGroup/both', form)
      if (res.isSuccess) {
        this.id = res.data
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.ifAdd = true
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 修改
    async update() {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of insertRecords) {
        form.detailList.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of updateRecords) {
        form.detailList.push(item)
      }
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.put('/Common/BMenuGroup/both', form)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 锁定
    async lock() {
      const { data: res } = await this.$http.put('/Common/BMenuGroup/lock', {
        id: this.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('锁定成功！')
      this.BindText()
    },
    // 解锁
    async unlock() {
      const { data: res } = await this.$http.put('/Common/BMenuGroup/unlock', {
        id: this.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('解锁成功！')
      this.BindText()
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      // 重复行
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['groupName', 'vuePath'])
      if (this.errIndex.length > 0) {
        flag = false
        this.$message.error('验证失败,请核对输入数据')
        return false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 获取数据
    async BindText() {
      this.IfDataBindComplete = false
      if (this.id > 0) {
        const { data: res } = await this.$http.get('/Common/BMenuGroup/both', {
          params: {
            id: this.id
          }
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.form = res.data
        this.changeType(res.data.productionType, true)
      } else {
        this.form = {
          productionType: '',
          productionVersion: '',
          memo: '',
          detailList: []
        }
      }
      this.InitRight()
      this.$nextTick(() => {
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // table 点击删除列
    delete() {
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.sureDelete()
        })
        .catch(() => { })
    },
    async sureDelete() {
      const that = this
      const { data: res } = await that.$http.delete(
        '/Common/BMenuGroup', {
        data: {
          id: that.id,
          effectCondition: that.Authority.alEffectCondition,
          empower: []
        }
      })
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.del.success)
        that.IfExistModify = false
        that.back('del')
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    back(type) {
      if (this.IfExistModify) {
        this.$confirm('您已做出修改，是否关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            if (this.ifAdd) {
              this.$emit('SingleBack', -1)
            } else {
              switch (type) {
                case 'del':
                  this.$emit('SingleBack', -1)
                  break
                default:
                  this.$emit('SingleBack', this.id)
                  break
              }
            }
          })
          .catch(() => {
          })
      } else {
        if (this.ifAdd) {
          this.$emit('SingleBack', -1)
        } else {
          switch (type) {
            case 'del':
              this.$emit('SingleBack', -1)
              break
            default:
              this.$emit('SingleBack', this.id)
              break
          }
        }
      }
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
    },
    // 初始化界面
    InitSetting() {
      // 是否可添加行
      // this.tableToolbar = {
      //   buttons: [
      //     {
      //       code: 'insertOne',
      //       name: '新增1行',
      //       disabled: !this.Authority.edit
      //     },
      //     {
      //       code: 'insertTen',
      //       name: '新增10行',
      //       disabled: !this.Authority.edit
      //     }
      //   ]
      // }
    },
    // 返回人员
    sureBackPerson(obj) {
      if (obj && obj.name) {
        this.areas.forEach(area => {
          for (let row of area.rows) {
            for (let col of area.cols) {
              if (col.property === this.colProperty) {
                row[this.colProperty] = obj.name
              }
            }
          }
        })
      }
    },
    // 绑定下拉框
    async BindComBox() {
      this.ComBoxItems.productionVersion = []
      this.ComBoxItems.productionType = []
      const { data: selectRes } = await this.$http.get('/Common/BMenuGroup/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'ProductionType':
              this.ComBoxItems.productionType.push(item)
              break
          }
        }
      }
    },
    // 初始化
    InitColumn() {
      this.tableColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [<el-tooltip class="tooltipItem"
                  effect="light" content={row.repeatText} placement="right" >
                  <div style="width: 100%; height: 100%">
                    <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                  </div>
                </el-tooltip>]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        { field: 'delete', title: '删除', visible: this.Authority.edit && !this.dontEdit && !this.form.lockerID, width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.removeRowForTable(row, this.$refs.xTable, this.$data) }} ></i>] } } },
        {
          field: 'groupName',
          title: '模块',
          editRender: { name: "input" },
          filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'vuePath',
          title: '页面',
          editRender: { name: "input" },
          filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'frontEngineer',
          title: '前端研发',
          editRender: { name: "$input", attrs: { disabled: true } },
          filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'backEngineer',
          title: '后端研发',
          editRender: { name: "$input", attrs: { disabled: true } },
          filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'techTester',
          title: '技术测试',
          editRender: { name: "$input", attrs: { disabled: true } },
          filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'businessTester',
          title: '业务测试',
          editRender: { name: "$input", attrs: { disabled: true } },
          filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'dMemo',
          title: '说明',
          editRender: { name: "input" },
        },
      ]
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // cell激活控制
    activeMethod({ column }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit || this.form.lockerID > 0 || this.dontEdit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit || this.form.lockerID > 0 || this.dontEdit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 快捷键
    visibleMethod({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.Authority.edit
          if (!column) {
            item.visible = false
          } else if ((item.code === 'pickMan' || item.code === 'clear' || item.code === 'setNull') &&
            (column.property === 'frontEngineer' || column.property === 'backEngineer'
              || column.property === 'techTester' || column.property === 'businessTester')) {
            item.visible = true
          } else if (item.code === 'batchInput' && column.property === 'groupName') {
            item.visible = true
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    async contextMenuClickEvent({ menu }) {
      switch (menu.code) {
        case 'pickMan':
          this.$refs.EmployeeSelect.formVisible = true
          break
        case 'clear':
        case 'setNull':
          this.areas.forEach(area => {
            for (let row of area.rows) {
              for (let col of area.cols) {
                if (col.property === this.colProperty) {
                  menu.code === 'clear'
                    ? row[this.colProperty] = ''
                    : row[this.colProperty] = '/'
                }
              }
            }
          })
          break
        case 'batchInput':
          this.$refs.BatchInput.formVisible = true
          break
      }
    },
    // table工具栏方法
    toolbarButtonClickEvent({ code }) {
      switch (code) {
        case 'insertOne':
          this.insertEvent()
          break
        case 'insertTen':
          this.insertTenEvent()
          break
      }
    },
    // 新增一行
    insertEvent() {
      let record = {}
      this.$refs.xTable.insertAt(record, -1)
      this.IfExistModify = true
    },
    // 新增10行
    insertTenEvent() {
      let record = {}
      for (var i = 0; i < 10; i++) {
        this.$refs.xTable.insertAt(record, -1)
      }
      this.IfExistModify = true
    },
    // 当类型改变
    async changeType(type, isInit = false) {
      this.ComBoxItems.productionVersion = []
      if (!type || type === '') {
        this.form.productionVersion = ''
        return
      }
      const { data: res } = await this.$http.post(`/Common/ProductVersionSet/list?sqlTitle=${type}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data) {
        this.ComBoxItems.productionVersion.push({
          name: item.productionVersion,
          value: item.productionVersion
        })
      }
      const option = this.ComBoxItems.productionVersion.filter(item => {
        return item.value === this.form.productionVersion
      })
      if (!isInit && option.length <= 0) {
        this.form.productionVersion = ''
      }
    },
  },
  computed: {
    tableHeight() {
      const headerHeight = 80
      const cardMaring = 15 * 2
      const cardPadding = 10 * 2
      const button = 40
      const elForm = 65
      const divider = this.$store.state.ykDivider
      return Number(this.$store.state.clientHeight) -
        headerHeight - cardMaring - cardPadding - elForm -
        divider - button
    },
  },
  watch: {
    form: {
      handler() {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.card {
  height: calc(100vh - @header-height - (@main-margin * 2));
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}
.buttonContainer {
  width: 100%;
  // display: flex;
  // justify-content: center;
}
</style>
